import { AdAccountsByUserQuery } from '../../types';
import { BrandItem } from './useFetchAdAccountByUser';

export const getBrandItems = (
  orgId: string,
  adAccounts: AdAccountsByUserQuery['adAccountsByUser']['edges']
): BrandItem[] => {
  const adAccountsByUserDataList = adAccounts.filter((adAccount) => adAccount.node.organizationId === orgId);

  if (adAccountsByUserDataList) {
    const adAccountsListBuilder: BrandItem[] = [];

    for (const adAccountByUser of adAccountsByUserDataList) {
      const { node } = adAccountByUser;

      const existingAdAccountsList = adAccountsListBuilder.find(
        (adAccount) => adAccount.id === node.brand?.id && adAccount.name === node.brand?.name
      );
      if (existingAdAccountsList) {
        existingAdAccountsList.accountList.push({
          id: node.id,
          label: node.name,
          isBaymaxEnabled: node.isBaymaxEnabled || false,
        });
      } else if (node.brand?.id && node.brand?.name) {
        adAccountsListBuilder.push({
          id: node.brand?.id,
          name: node.brand?.name,
          accountList: [
            {
              id: node.id,
              label: node.name,
              isBaymaxEnabled: node.isBaymaxEnabled || false,
            },
          ],
        });
      }
    }

    return adAccountsListBuilder;
  }

  return [];
};
